/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

/**
 * A plain chain link — RecipientStatusBadge's "Link expired" icon, as in the
 * client's status design (https://prnt.sc/F_usrM0hB1M2). It replaces a
 * crossed-out two-circle glyph the client found confusing (2026-09-23 Discord).
 * Colour comes from `fill`, like the Eye*Icon status icons beside it.
 */
function LinkIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.fill || props.stroke || '#AE0C0C';

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}

export default LinkIcon;
